import { ActionNames } from '_constants'


const actionProcessor = store => next => action => {

    if (!action.type.startsWith("SEARCH_QUICK") && store.getState().ui.quickSearch.searching === true) {
        store.dispatch({ type: ActionNames.SEARCH_QUICK_CLEAR })
    }

    if (!action.type.startsWith("ALERT") && store.getState().ui.alert.message !== undefined && (store.getState().ui.alert.type !== 'alert-success' && store.getState().ui.alert.type !== 'alert-warning')) {
        store.dispatch({ type: ActionNames.ALERT_CLEAR })
    }


    next(action);
}

export default actionProcessor